import React, { useContext } from "react";
import Subscription from "./Subscription";
import StorageManagement from "./StorageManagement";
import { SettingContext } from "../SettingContext";
import { IsFeatureReady } from "src/constants/features";

export default function SubscriptionPage() {
    const { isAccountOwner, hasBillingPermission } = useContext(SettingContext);

    return (
        <>
            {hasBillingPermission && (
                <Subscription />
            )}

            {isAccountOwner && IsFeatureReady.storageManagement() && (
                <StorageManagement />
            )}
        </>
    );
}
